// @ts-nocheck

import "./DraggableTableRow.st.css.js";
import { classesRuntime, statesRuntime } from "../../stylable-esm-runtime.js";



var _namespace_ = "DragHandleTableCell569479887";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"DragHandleTableCell569479887__root","trigger":"DragHandleTableCell569479887__trigger"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




